<script>
export default {
  name: 'AndroidChrome',
};
</script>

<template>
  <div>
    <!-- Android Chrome -->

    <ol>
      <li>
        Near the top right corner, open the Chrome menu
        <v-icon class="material-icons-round">more_vert</v-icon>
      </li>
      <li>
        Choose
        <b>Add to Home screen</b>
      </li>
      <li>
        Tap
        <strong>Add</strong>
      </li>
    </ol>

    <p class="body-2">
      Note: This is a web app so you can install it right from here. Once you do, it works just like
      other apps&mdash;even offline. Plus, you never have to install updates and it works on every
      device.
    </p>
  </div>
</template>

<style lang="scss" scoped>
// @import '@/design/help.scss';
</style>
